// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TripLink{background:#fff;box-shadow:1px 1px 1px rgba(0,0,0,.15);color:#c33d2b;font-size:1rem;padding:.5rem 0;width:200px;text-align:center;transform:translate(-50%, 10px)}", ""]);
// Exports
module.exports = exports;
